import { Typography } from "@material-ui/core";
import { get } from "lodash-es";
import React from "react";

export default function FileType({ title, file }) {
  console.log("file ", file);
  const [fileFormat] = get(file, "name", "")
    .split("/")
    .reverse()[0]
    .split(".")
    .reverse();

  const fileName = get(file, "name", "").split("/").reverse()[0];

  const fileFormatIcon =
    {
      pdf: "/assets/pdf.svg",
      jpg: "/assets/jpg.svg",
      xls: "/assets/xls.svg",
    }[fileFormat] || "/assets/fileFormat.svg";

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "row",
      }}
    >
      <img src={fileFormatIcon} alt={`${title}-file-icon`} />
      <div
        style={{
          marginLeft: 34,
          textAlign: "left",
        }}
      >
        <Typography variant="h6">{title}</Typography>
        <Typography>{fileName || "File name: -"}</Typography>
      </div>
    </div>
  );
}
